import { IRoute, SideBar } from '~/components/sidebar';
import { useOrganisationContext } from '~/contexts/organisation-context';
import React from 'react';

import { AuthRolesEnum } from '../../enums';

export const OrganisationSettingsSidebar: React.FC = () => {
  let { currentOrganisation } = useOrganisationContext();

  let hrefBase = '/[organisationId]';
  let asBase = `/${currentOrganisation?._id || ''}`;
  let routes = React.useMemo(() => {
    let value: Array<IRoute> = [
      {
        translationKey: 'overviewScreen.title',
        role: AuthRolesEnum.Member,
        href: `${hrefBase}`,
        as: `${asBase}`,
      },
      {
        translationKey: 'settings.generalSettings',
        role: AuthRolesEnum.Admin,
        href: `${hrefBase}/settings/general`,
        as: `${asBase}/settings/general`,
      },
      {
        translationKey: 'settings.email.settings',
        role: AuthRolesEnum.Admin,
        href: `${hrefBase}/settings/email`,
        as: `${asBase}/settings/email`,
      },
      {
        translationKey: 'adminSettings',
        role: AuthRolesEnum.Reseller,
        href: `${hrefBase}/settings/admin`,
        as: `${asBase}/settings/admin`,
      },
      {
        translationKey: 'brandingSettings',
        role: AuthRolesEnum.Admin,
        href: `${hrefBase}/settings/branding`,
        as: `${asBase}/settings/branding`,
      },
      {
        translationKey: 'settings.payment',
        role: AuthRolesEnum.Admin,
        href: `${hrefBase}/settings/payments`,
        as: `${asBase}/settings/payments`,
      },
      {
        translationKey: 'settings.joyn.title',
        role: AuthRolesEnum.Admin,
        href: `${hrefBase}/settings/joyn`,
        as: `${asBase}/settings/joyn`,
      },
      {
        translationKey: 'settings.qualityGuard.title',
        role: AuthRolesEnum.Admin,
        href: `${hrefBase}/settings/quality-guard`,
        as: `${asBase}/settings/quality-guard`,
      },
      {
        translationKey: 'usersPage.usersTitle',
        role: AuthRolesEnum.Admin,
        href: `${hrefBase}/settings/users`,
        as: `${asBase}/settings/users`,
      },
      {
        translationKey: 'api-keys',
        role: AuthRolesEnum.Admin,
        href: `${hrefBase}/settings/api-keys`,
        as: `${asBase}/settings/api-keys`,
      },
      {
        translationKey: 'quotas.title',
        role: AuthRolesEnum.Admin,
        href: `${hrefBase}/settings/quotas`,
        as: `${asBase}/settings/quotas`,
      },
      {
        translationKey: 'logs',
        role: AuthRolesEnum.Admin,
        href: `${hrefBase}/settings/logs`,
        as: `${asBase}/settings/logs`,
      },
      {
        translationKey: 'deviceLogs.title',
        role: AuthRolesEnum.Admin,
        href: `${hrefBase}/settings/device-logs`,
        as: `${asBase}/settings/device-logs`,
      },
      {
        translationKey: 'Telemetry',
        role: AuthRolesEnum.Admin,
        href: '/[organisationId]/telemetry',
        as: `${asBase.split('/settings')[0]}/telemetry`,
      },
    ];

    return value;
  }, []);

  return <SideBar routes={routes} />;
};
